exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-badge{-ms-flex-align:center;align-items:center;border-radius:30px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:30px;-ms-flex-pack:center;justify-content:center;width:30px;transition:background-color .7s ease-in}.badge-text{font-family:\"Inter-Bold\",Helvetica;font-size:14px;font-weight:700;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/badge/circle-badge/circle-badge.scss
// module id = 4988
// module chunks = 0